module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_9005.2b489235.png";